module.exports = __webpack_public_path__ + "static/media/login-signup-signin-img.8c22ea77.png";